import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  start: {
    display: 'flex',
    alignItems: 'center',
    color: '#7F8487',
    fontSize: theme.size.sm,
    textAlign: 'center'
  },

  addParticipantButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '0.5rem',

    '& .text': {
      fontSize: theme.size.sm
    },

    '& .icon': {
      marginRight: '10px'
    }
  },

  iconHolder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '0.3125rem'
  },

  icon: {
    fontSize: theme.size.base,
    color: '#7F8487',
    cursor: 'pointer'
  },

  closed: {
    marginTop: '0',
    marginBottom: '1rem'
  }
}))

export default useStyles
